import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../hook/AuthProvider";

interface RequireTokenProps {
  children: React.ReactNode;
  redirectPath?: string;
  loadingComponent?: React.ReactNode;
}

const RequireToken: React.FC<RequireTokenProps> = ({
  children,
  redirectPath = "/login",
  loadingComponent = <div></div>,
}) => {
  const { accessToken, isInit } = useAuth();



  useEffect(() => {
    

    if (window.parent && window.parent !== window) {

      if (isInit && !accessToken) {
        window.parent.location.reload();
      }
    }
  }, [accessToken, isInit]);

  if (!isInit) {
    return <>{loadingComponent}</>;
  }

  if (!accessToken) {
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};

export default RequireToken;
